/*
 * @Author: bbqin
 * @Date: 2022-10-20 13:35:55
 * @LastEditTime: 2023-09-07 15:38:48
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\libs\beautiful-dnd\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component, cloneElement } from 'react';
import ReactDOM from 'react-dom';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { throttle, debounce } from '../utils';

require('./index.less');

const defaultProps = {
    prefixCls: 'beautiful-dnd',
    // 拖拽时回调，用于样式调整
    onSnapshotDragging: null,
    // 是否可拖拽
    draggable: true,
    // 拖拽数据列表
    items: [],
    // 子元素渲染
    renderItem: null,
    // 拖拽区域id
    droppableId: '_beautiful_dnd_id',
    onBeforeDragStart: null,
    onBeforeCapture: null,
    onDragUpdate: null,
    onDragEnd: null,
    onDragStart: null,
    // 布局方式
    direction: 'vertical',
    // 显示隐藏
    visibleItems: {},
};

// 容器项样式
const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: 20 * 2,
    margin: `0 0 20px 0`,

    // change background colour if dragging
    background: isDragging ? 'lightgreen' : 'grey',

    // styles we need to apply on draggables
    ...draggableStyle,
});

// 容器样式
const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? 'lightblue' : 'lightgrey',
    padding: 20,
    width: 250,
});

// 排序
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

// 移动
const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
};

class ReactBeautifulDnd extends Component {

    static defaultProps = defaultProps

    constructor(props) {
        super(props);
        this.state = {
            items: props.items,
            droppableId: props.droppableId,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.items) {
            this.setState({ items: nextProps.items });
        }
    }

    /**
     * 拖拽开始时触发
     */
    onDragStart = (result, provided) => {
        const { onDragStart } = this.props;
        onDragStart && onDragStart(result, provided);
    }

    /**
     * 拖拽结束时触发
     */
    onDragEnd = result => {
        const { onDragEnd, dragResponse } = this.props;
        const { source, destination } = result;

        dragResponse && this.setState({
            dragoverIndex: -1,
            dragoverPosition: '',
        });
        // dropped outside the list
        if (!destination) {
            return;
        }
        const sInd = source.droppableId;
        const dInd = destination.droppableId;

        const { items } = this.state;

        if (sInd === dInd) {
            const dragItem = items[source.index];
            const nextItems = reorder(items, source.index, destination.index);
            this.setState({ items: nextItems }, () => {
                onDragEnd && onDragEnd(nextItems, dragItem);
            });
        } else {
            // const nextItems = move(sourceData, destinationData, source, destination);
            onDragEnd && onDragEnd(items);
        }
    };

    getItems = () => {
        const {
            renderItem,
            draggable = true,
            onSnapshotDragging,
            prefixCls,
            visibleItems,
        } = this.props;

        const { items, dragoverIndex, dragoverPosition } = this.state;

        return items.map((item, index) => {
            if (!item) { return; }
            const { $id } = item;
            const visible = visibleItems[$id];
            const visibleCls = visible === false ? prefixCls + '-item-hidden' : '';
            const hoverCls = dragoverIndex === index && dragoverPosition ? `drag-over-item-${dragoverPosition}` : '';
            return (
                <Draggable
                    key={$id}
                    index={index}
                    draggableId={`${$id}`}
                    isDragDisabled={draggable ? item.disabled : !draggable}
                >
                    {(provided, snapshot) => {
                        const draggingCls = snapshot.isDragging ? prefixCls + '-item-dragging' : '';
                        if (snapshot.isDragging) {
                            // if ($modal) {
                            //     const offset = $modal.getBoundingClientRect() || { x: 0, y: 0 }; // your fixed container left/top position
                            //     const x = provided.draggableProps.style.left - offset.x;
                            //     const y = provided.draggableProps.style.top - offset.y;
                            //     provided.draggableProps.style.left = x;
                            //     provided.draggableProps.style.top = y;
                            // }
                            // 用于计算  transform等导致偏移量
                            onSnapshotDragging && onSnapshotDragging(provided);
                        }
                        return (
                            <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                // {...provided.dragHandleProps}
                                // onClick={(event) =>this.handleDrag(event, provided, snapshot, item)}
                                onKeyDown={event =>
                                    this.onKeyDown(event, provided, snapshot, item)
                                }
                                className={`${prefixCls}-item ${hoverCls} ${draggingCls} ${visibleCls}`}
                                style={{ ...provided.draggableProps.style }}
                            // style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                            >
                                <div style={{ display: 'none' }}
                                    {...provided.dragHandleProps}
                                >drag me, 设置一个默认拖拽句柄，避免报错</div>
                                {
                                    renderItem(item, index, {
                                        connectDragSource: DragSource => {
                                            return cloneElement(DragSource, { ...provided.dragHandleProps });
                                        },
                                    })}
                            </div>
                        );
                    }}
                </Draggable>);
        });
    }

    onDragUpdate = debounce((...params) => {

        const {
            prefixCls,
            onDragUpdate,
            dragResponse,
        } = this.props;

        if (!dragResponse) {
            onDragUpdate && onDragUpdate(...params);
            return false;
        }

        let { destination, source } = params[0];
        if (destination && destination.index >= 0 && source && source.index >= 0) {
            const current = ReactDOM.findDOMNode(this);
            const itemDom = current?.querySelectorAll(`.${prefixCls}-item`);
            const sourceDom = itemDom[source.index];
            const destinationDom = itemDom[destination.index];

            if (!itemDom.length || !sourceDom || !destinationDom) {
                return;
            }

            const sourceRect = sourceDom.getBoundingClientRect();
            const destinationRect = destinationDom.getBoundingClientRect();

            let dragoverPosition = '';

            // if (source.index >= destination.index) {
            //     dragoverIndex = destination.index - 1;
            // } else if (source.index < destination.index) {
            //     dragoverIndex = destination.index;
            // }

            let dragoverIndex = destination.index;

            if (sourceRect.y - destinationRect.y >= 16) {
                dragoverPosition = 'next';
            } else if (sourceRect.y - destinationRect.y < 16) {
                dragoverPosition = 'prev';
            }

            if (source.index === destination.index) {
                if (destination.index - 1 >= 0) {
                    dragoverIndex = destination.index - 1;
                    dragoverPosition = 'next';
                } else {
                    dragoverIndex = destination.index + 1;
                    dragoverPosition = 'prev';
                }
            }

            this.setState({
                dragoverIndex,
                dragoverPosition,
            });
        }

        // 在区域之外
        if (!destination) {
            this.setState({
                dragoverIndex: -1,
                dragoverPosition: '',
            });
        }
        // console.log(params);
        onDragUpdate && onDragUpdate(...params);
        // 动画是200ms
    }, 100)

    render() {

        const {
            draggable,
            droppableId,
            prefixCls,
            onBeforeDragStart,
            onBeforeCapture,
            onDragUpdate,
            direction,
            dragResponse,
        } = this.props;

        return <DragDropContext
            onBeforeDragStart={(...params) => {
                // console.log(params);
                onBeforeDragStart && onBeforeDragStart(...params);
            }}
            onBeforeCapture={(...params) => {
                // console.log(params);
                onBeforeCapture && onBeforeCapture(...params);
            }}
            onDragUpdate={this.onDragUpdate}
            onDragEnd={this.onDragEnd}
            onDragStart={this.onDragStart}
        >
            <div
                className="dnd-list-wrapper"
            >
                <Droppable key={`droppable_${droppableId}`} droppableId={`droppable_${droppableId}`} direction={direction} isDropDisabled={!draggable}>
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            key={droppableId}
                            className={`${prefixCls}-content`}
                            {...provided.droppableProps}
                        // style={getListStyle(snapshot.isDraggingOver)}
                        >
                            {/* <div style={{ display: 'none' }}>{provided.placeholder}</div> */}
                            {this.getItems()}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </div>
        </DragDropContext>;
    }
}

export default ReactBeautifulDnd;